import { Injectable } from '@angular/core';
import { Globals } from '@app/shared/globals/globals';
import { NotifyUtils } from '@app/shared/utils/notify.utils';
import { Observable, firstValueFrom } from 'rxjs';
import { ContactInformationAPIService } from '../../api/contact-information/contact-information-api.service';
import { SettingsMessages } from '../../locale/settings.messages';
import { ContactInformationDto } from '../../model/contact-information.model';
import { InFlightRegistry } from '@app/shared/utils/in-flight-registry';

const WRITE_KEY = 'write';

@Injectable({
  providedIn: 'root'
})
export class ContactInformationBusinessService {

  // A write already in flight coalesces a duplicate call onto the same promise (see InFlightRegistry)
  // rather than rejecting it, which previously surfaced as an unhandled rejection (Sentry FRONTEND-3HT).
  private writes = new InFlightRegistry();

  constructor(
    private contactInformationAPIService: ContactInformationAPIService,
    private notifyUtils: NotifyUtils,
    public globals: Globals
  ) { }

  get(): Observable<ContactInformationDto> {
    return this.contactInformationAPIService.get();
  }

  update(userContactInformation: ContactInformationDto): Promise<ContactInformationDto> {
    userContactInformation.linkedIn = (userContactInformation.linkedIn || '').replace('https://', '').replace('http://', '').replace('www.', '');
    userContactInformation.phoneNumber = (userContactInformation.phoneNumber || '').trim();
    if ((userContactInformation.twitterHandle || '').startsWith('@')) {
      this.globals.user.twitterHandle = userContactInformation.twitterHandle.substring(1);
    }

    return this.writes.run(WRITE_KEY, () =>
      firstValueFrom(this.contactInformationAPIService.update(userContactInformation))
        .then(res => {
          this.notifyUtils.notify(SettingsMessages.SUCCESS_PROFILE_UPDATED);
          this.globals.user.preferredContactMethod = res.preferredContactMethod;
          this.globals.user.phoneNumber = res.phoneNumber;
          this.globals.user.linkedIn = res.linkedIn;
          this.globals.user.twitterHandle = res.twitterHandle;
          return res;
        })
    );
  }
}
